module.exports = __webpack_public_path__ + "img/logo.59c6561c.png";